// src/utilities/math-utilities.ts
var mathUtilities = {
  map(x, inMin, inMax, outMin, outMax) {
    return (x - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
  }
};

export {
  mathUtilities
};
